import * as ActionTypes from '../constants/ActionTypes';

import SpartaService from '../services/SpartaService';

const spartaService = new SpartaService();

export function updateStats(params) {
    return dispatch => {
        spartaService.getStats(params).then((stats) => {
            dispatch({ type: ActionTypes.UPDATE_STATS, stats });
        }).catch(error => {
            dispatch({ type: ActionTypes.UPDATE_STATS_ERROR, error });
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/statsActions.js